module.exports = __webpack_public_path__ + "0d13045c4ed91b99e48f3db568b94611.png";